import React from 'react'
import OrderDetailListingHeader from './OrderDetailListingHeader/OrderDetailListingHeader'
import OrderDetailTabsData from './OrderDetailTabsData/OrderDetailTabsData'
import ShowAlert from 'src/component/Global/ShowAlert'
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem'

const OrderDetail = () => {
    const [{ system_alert_list }, {  }, { }] = useDOMAttachToSystemStore();

    return (
        <>
            {system_alert_list?.orderDetailNotFound && 
                <div className='mt-4 mb-4'>
                    <ShowAlert onlyShowMessage={['orderDetailNotFound']}/>
                </div>}
            <div className="card-box p-t-30 mb-5">
                <OrderDetailListingHeader />
                <OrderDetailTabsData />
            </div>
        </>
    )
}

export default OrderDetail